import { render, staticRenderFns } from "./itemsDiscount.vue?vue&type=template&id=65011056&scoped=true"
import script from "./itemsDiscount.vue?vue&type=script&lang=js"
export * from "./itemsDiscount.vue?vue&type=script&lang=js"
import style0 from "./itemsDiscount.vue?vue&type=style&index=0&id=65011056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65011056",
  null
  
)

export default component.exports